import { C } from "../constants/colors";

export function ProgressBar({step,total}){
  return(
    <div style={{display:"flex",gap:6,marginBottom:28}}>
      {Array.from({length:total}).map((_,i)=>(
        <div key={i} style={{flex:1,height:4,borderRadius:2,background:i<step?C.teal:C.border,transition:"background 0.3s"}}/>
      ))}
    </div>
  );
}

export function Btn({children,onClick,variant="primary",disabled,style:s}){
  const base={padding:"10px 22px",borderRadius:8,border:"none",cursor:disabled?"not-allowed":"pointer",fontWeight:600,fontSize:14,transition:"opacity 0.2s",opacity:disabled?0.5:1,...s};
  const v={primary:{background:C.navy,color:C.white},secondary:{background:C.tealLight,color:C.teal,border:`1px solid ${C.teal}`},ghost:{background:"transparent",color:C.muted,border:`1px solid ${C.border}`}};
  return <button style={{...base,...v[variant]}} onClick={onClick} disabled={disabled}>{children}</button>;
}

export function Card({children,style:s}){return <div style={{background:C.white,borderRadius:12,padding:24,border:`1px solid ${C.border}`,...s}}>{children}</div>;}
export function SectionTag({label,color=C.teal}){return <span style={{background:color+"22",color,fontSize:11,fontWeight:700,letterSpacing:1,padding:"3px 10px",borderRadius:20,textTransform:"uppercase"}}>{label}</span>;}
export const labelStyle={display:"block",fontSize:12,fontWeight:600,color:C.muted,marginBottom:6,letterSpacing:0.3};
export const inputStyle={width:"100%",padding:"9px 12px",border:`1px solid ${C.border}`,borderRadius:8,fontSize:14,color:C.text,background:C.white,outline:"none",boxSizing:"border-box",fontFamily:"inherit"};

export function TriBtn({options,value,onChange}){
  return(
    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
      {options.map(([v,lbl])=>(
        <button key={v} onClick={()=>onChange(v)}
          style={{padding:"5px 13px",borderRadius:20,border:`1px solid ${value===v?C.teal:C.border}`,background:value===v?C.tealLight:C.white,color:value===v?C.teal:C.muted,fontWeight:600,fontSize:12,cursor:"pointer",whiteSpace:"nowrap"}}>
          {lbl}
        </button>
      ))}
    </div>
  );
}

export function Nav({screen,setScreen,hasAudit,hasInvoice,hasPlan,onLogout}){
  const auditScreens=["baseline","audit-prep","audit"];
  const items=[
    {id:"dashboard",       label:"Dashboard",    icon:"⊞", always:true},
    {id:"baseline",        label:"Setup",        icon:"📋", always:true},
    {id:"audit",           label:"Audit",        icon:"⚖️", always:true},
    {id:"waste-hub",       label:"Waste Data",   icon:"📈", always:true},
    {id:"results",         label:"Results",      icon:"📊", show:hasAudit},
    {id:"location-detail", label:"By Location",  icon:"📍", show:hasAudit},
    {id:"plan",            label:"Action Plan",  icon:"🎯", show:hasPlan},
  ];
  const active=(id)=> id==="baseline" ? auditScreens.includes(screen) : screen===id;
  return(
    <div style={{background:C.white,borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",padding:"0 24px",gap:4}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginRight:24,padding:"12px 0"}}>
        <div style={{width:30,height:30,borderRadius:7,background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:C.white,fontSize:12}}>WF</div>
        <div><div style={{fontWeight:800,color:C.navy,fontSize:13,lineHeight:1.1}}>WASTE FREE</div><div style={{fontWeight:400,color:C.teal,fontSize:9,letterSpacing:2}}>TAHOE</div></div>
      </div>
      {items.filter(i=>i.always||i.show).map(item=>(
        <button key={item.id} onClick={()=>{
          if(item.id==="location-detail"){
            // handled by App via navigateTo
            setScreen("location-detail");
          } else {
            setScreen(item.id);
          }
        }}
          style={{padding:"14px 16px",border:"none",background:"transparent",cursor:"pointer",fontSize:13,
            fontWeight:active(item.id)?700:400,color:active(item.id)?C.teal:C.muted,
            borderBottom:active(item.id)?`2px solid ${C.teal}`:"2px solid transparent",transition:"all 0.15s"}}>
          {item.icon} {item.label}
        </button>
      ))}
      <button onClick={onLogout} style={{marginLeft:"auto",padding:"6px 12px",border:`1px solid ${C.border}`,borderRadius:6,background:"transparent",cursor:"pointer",fontSize:12,color:C.muted,fontWeight:500}}>Sign out</button>
    </div>
  );
}

// Shared chrome for every screen except login/loading/org-onboarding — reproduces the
// original inline `wrap()` closure exactly, just parameterized via navProps.
export function Layout({navProps,children}){
  return(
    <div style={{minHeight:"100vh",background:C.sand,fontFamily:"'Inter',system-ui,sans-serif",color:C.text}}>
      <Nav {...navProps}/>
      <div style={{padding:"32px 24px 60px",maxWidth:820,margin:"0 auto"}}>{children}</div>
    </div>
  );
}
